module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 2);
}([function (t, e) {
  t.exports = require("prop-types");
}, function (t, e) {
  t.exports = require("react");
}, function (t, e, n) {
  "use strict";

  n.r(e), n.d(e, "useKonami", function () {
    return h;
  });

  var r = n(1),
      o = n.n(r),
      i = n(0),
      u = n.n(i),
      s = function () {
    function t(t, e) {
      this.t = e, this.fn = t, this.timerIntervalID = setInterval(this.fn, this.t);
    }

    return t.prototype.stop = function () {
      return this.timerIntervalID && (clearInterval(this.timerIntervalID), this.timerIntervalID = null), this;
    }, t.prototype.start = function () {
      return this.timerIntervalID || (this.stop(), this.timerIntervalID = setInterval(this.fn, this.t)), this;
    }, t.prototype.reset = function (t) {
      return this.t = t, this.stop().start();
    }, t;
  }();

  var _a,
      p = {
    equals: function equals(t, e) {
      return !(!Array.isArray(t) || !Array.isArray(e)) && t.length === e.length && t.every(function (t, n) {
        return t === e[n];
      });
    }
  },
      c = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65],
      l = (_a = function a(t, e) {
    return (_a = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
    })(t, e);
  }, function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

    function n() {
      this.constructor = t;
    }

    _a(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
  }),
      f = {
    action: u.a.func,
    className: u.a.string,
    code: u.a.arrayOf(u.a.number),
    disabled: u.a.bool,
    onTimeout: u.a.func,
    resetDelay: u.a.number,
    timeout: u.a.number
  },
      d = function (t) {
    function e(e) {
      var n = t.call(this, e) || this;
      return n.state = {
        done: !1,
        input: []
      }, n.timeoutID = null, n.onKeyUp = n.onKeyUp.bind(n), n.resetInput = n.resetInput.bind(n), n;
    }

    return l(e, t), e.prototype.componentDidMount = function () {
      var t = this,
          e = this.props.resetDelay;
      document.addEventListener("keyup", this.onKeyUp);
      var n = Number(e);
      0 !== n && (this._timer = new s(function () {
        return t.resetInput();
      }, n));
    }, e.prototype.componentWillUnmount = function () {
      var t = this.props.resetDelay;
      this.timeoutID && clearTimeout(this.timeoutID), 0 !== t && this._timer.stop(), document.removeEventListener("keyup", this.onKeyUp);
    }, e.prototype.shouldComponentUpdate = function (t, e) {
      return this.props.className !== t.className || this.props.disabled !== t.disabled || this.state.done !== e.done;
    }, e.prototype.onKeyUp = function (t) {
      var e = this,
          n = this.state,
          r = n.done,
          o = n.input,
          i = this.props,
          u = i.action,
          s = i.code,
          a = i.disabled,
          c = i.onTimeout,
          l = i.resetDelay,
          f = i.timeout,
          d = Number(l);
      a || (0 !== d && this._timer.reset(d), o.push(t.keyCode), s && o.splice(-s.length - 1, o.length - s.length), this.setState({
        input: o
      }, function () {
        p.equals(e.state.input, s) && !r && (0 !== d && e._timer.stop(), e.setState({
          done: !0
        }, function () {
          "function" == typeof u && u();
        }), f && (e.timeoutID = setTimeout(function () {
          e.setState({
            done: !1
          }), "function" == typeof c && c();
        }, Number(f))));
      }));
    }, e.prototype.resetInput = function () {
      this.setState({
        input: []
      });
    }, e.prototype.render = function () {
      var t = this.props,
          e = t.children,
          n = t.className,
          r = t.disabled,
          i = this.state.done;
      return o.a.createElement("div", {
        className: "konami " + (null != n ? n : ""),
        style: {
          display: !i || r ? "none" : "block"
        }
      }, e);
    }, e;
  }(o.a.Component);

  d.defaultProps = {
    className: "",
    code: c,
    disabled: !1,
    resetDelay: 1e3
  }, d.propTypes = f;
  var y = d;

  var h = function h(t, e) {
    var n = (void 0 === e ? {} : e).code,
        o = void 0 === n ? c : n,
        i = Object(r.useState)([]),
        u = i[0],
        s = i[1],
        a = Object(r.useCallback)(function (e) {
      var n = u;
      n.push(e.keyCode), n.splice(-o.length - 1, u.length - o.length), s(n), n.join("").includes(o.join("")) && t();
    }, [u, s, o, t]);
    Object(r.useEffect)(function () {
      return document.addEventListener("keyup", a), function () {
        document.removeEventListener("keyup", a);
      };
    }, [a]);
  };

  e.default = y;
}]);